// eslint-disable-next-line import/prefer-default-export
export const menuList = [
  {
    id: 'insightTower',
    name: 'Insights Tower',
  },
];
